/** English mock data for UI kit previews (Figma palette–aligned). */

export const player = { nickname: 'Alex', tokens: 1240 };

export const contacts = [
  { id: '1', name: 'Lina', preview: 'See you tonight~', active: true },
  { id: '2', name: 'Mortifera', preview: 'The contract stands.', active: false },
  { id: '3', name: 'Iris', preview: 'That album stays sealed.', active: false },
  { id: '4', name: 'Kade', preview: 'You still owe me one.', active: false },
  { id: '5', name: 'Mara', preview: 'VIP lounge 11pm', active: false },
  { id: '6', name: 'Jun', preview: 'Shoot ran long.', active: false },
  { id: '7', name: 'Sable', preview: '…', active: false }
];

/** Long thread so chat preview scroll is obvious (wheel / trackpad; scrollbar hidden in UI). */
const CHAT_PREVIEW_THREAD = [
  ['character', 'You really came. I was starting to think you forgot about me.'],
  ['user', 'Never. I just got held up at work.'],
  ['character', 'image:shared'],
  [
    'character',
    'That one was from last session — still have the rest if you want to browse.'
  ],
  ['user', 'Later. Tell me how your day went first.'],
  ['character', 'Long. But better now that you’re here.'],
  ['user', 'The city was loud tonight. Traffic, horns, someone arguing outside the venue.'],
  ['character', 'You still notice everything. That’s why you’re dangerous here.'],
  ['user', 'Dangerous how?'],
  ['character', 'You remember details. People think they want that until they don’t.'],
  ['user', 'I only remember what matters.'],
  ['character', 'Flatterer.'],
  ['user', 'Truth.'],
  ['character', 'album:owned'],
  ['character', 'album:locked'],
  ['user', 'Okay, that locked one is cruel.'],
  ['character', 'Cruel is good for business. Mystery sells.'],
  ['user', 'You sound like marketing.'],
  ['character', 'I sound like someone who pays rent on this building.'],
  ['user', 'Fair.'],
  ['character', 'Come backstage after? Not a line — logistics. Crowd will swamp the bar.'],
  ['user', 'Text me the door code.'],
  ['character', 'Already sent. Check your pocket.'],
  ['user', '…when did you—'],
  ['character', 'You were looking at the stage. Easy.'],
  ['user', 'That’s unsettling.'],
  ['character', 'That’s the job.'],
  ['user', 'What job exactly?'],
  ['character', 'Keeping the room velvet. Keeping you coming back.'],
  ['user', 'You make it sound like a trap.'],
  ['character', 'Only if you want it to be.'],
  ['user', 'I don’t know what I want yet.'],
  ['character', 'Good. Uncertainty is honest.'],
  ['user', 'You rehearse these lines?'],
  ['character', 'Never. They’d sound worse.'],
  ['user', 'Liar.'],
  ['character', 'Optimist.'],
  ['user', 'Same thing sometimes.'],
  ['character', 'Finish your drink. Then we walk.'],
  ['user', 'Bossy.'],
  ['character', 'Efficient.'],
  ['user', 'Fine. Lead.'],
  ['character', 'Always do.'],
  ['user', 'We’ll see.'],
  ['character', 'We will.']
];

function buildChatPreviewMessages() {
  const out = [];
  let n = 0;
  for (const [role, text] of CHAT_PREVIEW_THREAD) {
    n += 1;
    if (text === 'image:shared') {
      out.push({
        id: `m${n}`,
        role: 'character',
        type: 'image',
        caption: 'Shared image'
      });
      continue;
    }
    if (text === 'album:owned') {
      out.push({
        id: `m${n}`,
        role: 'character',
        type: 'album',
        title: 'Velvet room — 18 photos',
        photoCount: 18,
        purchased: true
      });
      continue;
    }
    if (text === 'album:locked') {
      out.push({
        id: `m${n}`,
        role: 'character',
        type: 'album',
        title: 'After hours — 24 photos',
        photoCount: 24,
        purchased: false
      });
      continue;
    }
    out.push({
      id: `m${n}`,
      role,
      type: 'text',
      text
    });
  }
  return out;
}

export const chatMessages = buildChatPreviewMessages();

/** Square photo albums for sale (covers are 1:1 in UI). */
export const albumsForShop = [
  { id: 'a1', title: 'Dressing room mirror', photoCount: 12, price: 320 },
  { id: 'a2', title: 'Neon balcony night', photoCount: 20, price: 450 },
  { id: 'a3', title: 'Private polaroids', photoCount: 30, price: 600 }
];

export const tokenPacks = [
  { id: 'p1', label: 'Starter', amount: 100, price: '$0.99' },
  { id: 'p2', label: 'Popular', amount: 550, price: '$4.99' },
  { id: 'p3', label: 'Whale', amount: 1500, price: '$12.99' }
];

export const characterProfile = {
  name: 'Lina',
  description:
    'Front-desk charm, backstage secrets. She remembers every promise you almost kept.',
  relationshipLabel: 'Devoted',
  rpCurrent: 720,
  rpNext: 1000,
  preferences: '35mm prints · Late texts · Honest flattery'
};

/** Несколько карточек для превью окна персонажа со стрелками */
export const characterProfilesDemo = [
  characterProfile,
  {
    name: 'Mortifera',
    description: 'The contract stands. She does not forget debts or favors.',
    relationshipLabel: 'Trusting',
    rpCurrent: 12,
    rpNext: 20,
    preferences: 'Formal address · Night hours · Clear terms'
  },
  {
    name: 'Iris',
    description: 'That album stays sealed until you earn the key.',
    relationshipLabel: 'Neutral',
    rpCurrent: 3,
    rpNext: 10,
    preferences: 'Polaroids · Silence · Boundaries'
  }
];

export const relationshipUp = {
  from: 'Neutral',
  to: 'Trusting',
  rewardAlbum: { title: 'Velvet room — 18 photos', photoCount: 18, setId: 'demo-set', optional: true }
};

export const albumReward = {
  title: 'Velvet room — 18 photos',
  subtitle: 'Unlocked',
  photoCount: 18
};

export const characterAlbums = [
  { id: 'ca1', title: 'Lobby polaroids', photoCount: 8, owned: true },
  { id: 'ca2', title: 'Stairwell flash', photoCount: 10, owned: true },
  { id: 'ca3', title: 'Velvet room set', photoCount: 18, owned: false, price: 320 },
  { id: 'ca4', title: 'After hours film', photoCount: 24, owned: false, price: 600 }
];

export const gifts = [
  { id: 'g1', name: 'Single rose', price: 40, emoji: '🌹', giftType: 'Gift' },
  { id: 'g2', name: 'Truffle box', price: 120, emoji: '🍫', giftType: 'Gift' },
  { id: 'g3', name: 'VIP ticket', price: 300, emoji: '🎟️', giftType: 'Gift' }
];

export const characterItems = [
  { id: 'i1', name: 'Silk ribbon', price: 80, emoji: '🎀', itemType: 'AnalPlug' },
  { id: 'i2', name: 'Vintage mic', price: 200, emoji: '🎤', itemType: 'Stack' },
  { id: 'i3', name: 'Key to lounge', price: 500, emoji: '🗝️', itemType: 'Dildo' }
];

export const dialogueSample =
  'The lights dim. Her voice drops to a whisper—you are not supposed to be here this late, and yet the door was unlocked.';

export const choices = [
  { id: 'c1', label: 'Step inside and close the door.', tokenCost: null, gift: false },
  { id: 'c2', label: 'Slip her a tip and ask for five more minutes.', tokenCost: 25, gift: false },
  { id: 'c3', label: 'Offer the gift you brought.', tokenCost: null, gift: true }
];

export const toastSamples = [
  { id: 't1', message: '+120 RP · Trust increased', tone: 'success' },
  { id: 't2', message: 'New message from Lina', tone: 'info' },
  { id: 't3', message: 'Photo album unlocked: Velvet room (18 shots)', tone: 'reward' }
];

export const UI_DEMO = {
  TOP_BAR: 'topBar',
  CHAT: 'chat',
  ALBUM_SHOP: 'albumShop',
  TOKEN_SHOP: 'tokenShop',
  CHARACTER: 'character',
  TOASTS: 'toasts',
  RELATIONSHIP_UP: 'relationshipUp',
  ALBUM_REWARD: 'albumReward',
  CHARACTER_ALBUMS: 'characterAlbums',
  GIFTS: 'gifts',
  ITEM_SHOP: 'itemShop',
  DIALOGUE: 'dialogue',
  CHOICES: 'choices',
  NICKNAME: 'nickname',
  SETTINGS: 'settings'
};

export const UI_DEMO_LABELS = [
  { id: UI_DEMO.TOP_BAR, label: 'Top bar' },
  { id: UI_DEMO.SETTINGS, label: 'Settings' },
  { id: UI_DEMO.NICKNAME, label: 'Nickname' },
  { id: UI_DEMO.CHAT, label: 'Chat window' },
  { id: UI_DEMO.ALBUM_SHOP, label: 'Photo album shop' },
  { id: UI_DEMO.TOKEN_SHOP, label: 'Token packs' },
  { id: UI_DEMO.CHARACTER, label: 'Character window' },
  { id: UI_DEMO.TOASTS, label: 'Notifications' },
  { id: UI_DEMO.RELATIONSHIP_UP, label: 'Relationship level-up' },
  { id: UI_DEMO.ALBUM_REWARD, label: 'Photo album reward' },
  { id: UI_DEMO.CHARACTER_ALBUMS, label: 'Character photo albums' },
  { id: UI_DEMO.GIFTS, label: 'Gifts shop' },
  { id: UI_DEMO.ITEM_SHOP, label: 'Character items' },
  { id: UI_DEMO.DIALOGUE, label: 'Dialogue line' },
  { id: UI_DEMO.CHOICES, label: 'VN choices' }
];
